// src/components/affiliate/AffiliateExpedia.js

export default function AffiliateExpedia() {
  return (
    <div
      style={{
        display: "block",   // ⭐ FIXED: block-level so spacing works on mobile
        margin: "10px 0",
      }}
    >
      <a
        href="https://expedia.com/affiliates/expedia-home.yW9V7L6"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/assets/BEX_Logo_Horizontal_CMYK_FullColorDarkBlue--1024x199.jpg"
          alt="Expedia Logo"
          style={{
            width: "100%",
            maxWidth: "260px",
            height: "auto",
            borderRadius: "8px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            transition: "all 0.25s ease",
            cursor: "pointer",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-3px)";
            e.currentTarget.style.boxShadow = "0 6px 14px rgba(0,0,0,0.25)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.15)";
          }}
        />
      </a>
    </div>
  );
}
